(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initHavloReviews(root) {
    if (!root || root.dataset.havloInitialized === 'true') return;

    root.dataset.havloInitialized = 'true';

    var track = root.querySelector('[data-review-track]');
    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    var dotsContainer = root.querySelector('[data-review-dots]');

    if (!track) return;

    var cards = Array.prototype.slice.call(
      track.querySelectorAll('.havlo-review-card')
    );

    if (!cards.length) return;

    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var autoplayTimer = null;
    var userInteracting = false;

    function getGap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || 0);
    }

    function getScrollAmount() {
      if (!cards.length) return track.clientWidth;

      var cardWidth = cards[0].getBoundingClientRect().width;
      return cardWidth + getGap();
    }

    function scrollNext() {
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (track.scrollLeft >= maxScroll - 5) {
        track.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      }
    }

    function scrollPrev() {
      var amount = getScrollAmount();

      if (track.scrollLeft <= 5) {
        track.scrollTo({
          left: track.scrollWidth - track.clientWidth,
          behavior: 'smooth'
        });
      } else {
        track.scrollBy({
          left: -amount,
          behavior: 'smooth'
        });
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        userInteracting = true;
        scrollPrev();
        restartAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        userInteracting = true;
        scrollNext();
        restartAutoplay();
      });
    }

    /* ---------- Dots ---------- */

    function buildDots() {
      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';

      cards.forEach(function (card, index) {
        var dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'havlo-reviews__dot';
        dot.setAttribute('aria-label', 'Go to review ' + (index + 1));

        dot.addEventListener('click', function () {
          card.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });

          restartAutoplay();
        });

        dotsContainer.appendChild(dot);
      });

      updateDots();
    }

    function updateDots() {
      if (!dotsContainer) return;

      var dots = dotsContainer.querySelectorAll('.havlo-reviews__dot');

      if (!dots.length) return;

      var closestIndex = 0;
      var smallestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(
          card.getBoundingClientRect().left -
          track.getBoundingClientRect().left
        );

        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle(
          'is-active',
          index === closestIndex
        );
      });
    }

    var scrollUpdateTimeout;

    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollUpdateTimeout);

      scrollUpdateTimeout = window.setTimeout(function () {
        updateDots();
      }, 60);
    }, { passive: true });

    /* ---------- Autoplay ---------- */

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || cards.length < 2) return;

      stopAutoplay();

      autoplayTimer = window.setInterval(function () {
        if (!userInteracting) {
          scrollNext();
        }
      }, autoplaySpeed);
    }

    function restartAutoplay() {
      userInteracting = false;
      startAutoplay();
    }

    root.addEventListener('mouseenter', function () {
      stopAutoplay();
    });

    root.addEventListener('mouseleave', function () {
      startAutoplay();
    });

    root.addEventListener('focusin', function () {
      stopAutoplay();
    });

    root.addEventListener('focusout', function () {
      startAutoplay();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    /* ---------- Touch interaction ---------- */

    track.addEventListener('touchstart', function () {
      userInteracting = true;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function () {
      restartAutoplay();
    }, { passive: true });

    /* ---------- Keyboard ---------- */

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollNext();
        restartAutoplay();
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollPrev();
        restartAutoplay();
      }
    });

    buildDots();
    startAutoplay();

    /* ---------- Theme editor ---------- */

    document.addEventListener(
      'shopify:block:select',
      function (event) {
        var selectedBlock = event.target;

        if (
          selectedBlock &&
          root.contains(selectedBlock)
        ) {
          var card = selectedBlock;

          if (card.classList.contains('havlo-review-card')) {
            card.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }

          stopAutoplay();
        }
      }
    );

    document.addEventListener(
      'shopify:block:deselect',
      function (event) {
        if (
          event.target &&
          root.contains(event.target)
        ) {
          startAutoplay();
        }
      }
    );
  }

  function initAllHavloReviews() {
    document
      .querySelectorAll('[data-havlo-reviews]')
      .forEach(initHavloReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHavloReviews);
  } else {
    initAllHavloReviews();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var section = event.target;

      if (section && section.querySelector) {
        initHavloReviews(
          section.querySelector('[data-havlo-reviews]')
        );
      }
    }
  );
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
